module.exports = __webpack_public_path__ + "img/oldwoman.9c5dce20.png";